import * as actions from './stats-version-check.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { StatsService } from 'src/app/shared/services/stats.service';
import { loadingStatsVersionCheck } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class StatsVersionCheckEffects {
    private readonly actions$ = inject(Actions);
    private readonly statsService = inject(StatsService);


    save: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.statsService.versionCheck(action.query))
            .pipe(
                map((result: any) => actions.received({
                    result: result,
                })),
                catchError((error) => [
                    actions.error({
                        error
                    }),
                    // spxToasterActions.createError({
                    //     autoClose: error.autoclose ? 5000 : undefined,
                    //     messageText: error.message,
                    // }),
                ])
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingStatsVersionCheck
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingStatsVersionCheck
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap((data) => [
            spxSpinnerActions.hide({
                action: loadingStatsVersionCheck
            }),
            data.result.expireStatus === undefined || data.result.expireStatus === 'GREEN' ?
                spxToasterActions.createSuccess({
                    autoClose: 1,
                    messageText: `App store version is OK`,
                }) :
                data.result.expireStatus === 'YELLOW' ?
                    spxToasterActions.createSuccess({
                        autoClose: SpxToasterAutoCloseSpeedEnum.SLOW,
                        messageText: `App version will expire on ${data.result.expireDate}. Please update the app in the App Store, or in Google Play.`,
                    }) : data.result.expireStatus === 'ORANGE' ?
                        spxToasterActions.createWarning({
                            autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                            messageText: `App version will expire on ${data.result.expireDate}. Please update the app in the App Store, or in Google Play.`,
                        }) :
                        spxToasterActions.createWarning({
                            messageText: `The app is expired. Please update the app in the App Store, or in Google Play.`,
                        })
        ]))
    );
}
